export const legacyEquipmentPrompts = [
  {
    text: `I'm Searching for Equipment`,
    children: [
      {
        text: `Searching for New Equipment`,
        parentText: "I'm Searching for Equipment",
        url: 'https://www.legacyequipment.com/New-Equipment'
      },
      {
        text: `Looking for Used Equipment`,
        parentText: "I'm Searching for Equipment"
      },
      {
        text: `I Have a General Question `,
        parentText: "I'm Searching for Equipment"
      }
    ]
  },
  {
    text: `Help Ordering Parts`
  },
  {
    text: `My Machine Needs Service`,
    children: [
      {
        text: 'Schedule Equipment Service',
        parentText: 'My Machine Needs Service',
        url: 'https://www.legacyequipment.com/Service'
      }
    ]
  },
  {
    text: `Trade In`,
    children: [
      {
        text: `Get a Trade In Quote`,
        parentText: 'Trade In'
      }
    ]
  },
  {
    text: `Quick Question`
  }
]
